import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import images from '../../../services/images';
import ContentHeader from '../../parts/ContentHeader';
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest, httpAuthHeaders } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import initTreeView from '../../../services/initTreeView';
import appSession from '../../../services/session';
import { getApiData } from '../../../services/apiService';
// import DataTable from 'react-data-table-component';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chart } from 'primereact/chart';
import CustomerMap from '../../parts/CustomerMap';
 
function CustomerMapDashboard (){
    const [loading, setLoading] = useState(0);
    const [statistic, setStatistic] = useState([]);
    const [customers, setCustomers] = useState([]);
    const navigate = useNavigate();

    const [errors, setErrors] = useState([]);

    
    const [widget_data, setWidgetData] = useState({
        "total_low_stock": '---',
        "total_items": '---',
        "totaL_value": '---',
        "month_sales": '---',
        "total_sales_order": '---',
        "pending_deliveries": '---',
        "total_purchase_order": '---',
        "total_receivable_items": '---',
        "top_items": [],
        "low_stock_items": [],
        "sales_orders": [],
        "purchases_orders": []
    });
    const [top_items, setTopItems] = useState([]);
    const [low_stock_items, setLowStockItems] = useState([]);
    const [sales_orders, setSalesOrders] = useState([]);
    const [purchases_orders, setPurchasesOrders] = useState([]);

    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

   
    useEffect(() => {
        initTreeView()
        //Mounted
        fetchData()
    }, []);
   
    useEffect(() => {
        displayTopItems()
        displayLowStockItems()
        displaySalesOrderTable()
        displayPurchasesOrderTable()
    }, [widget_data]);

    useEffect(() => {
        const options = {
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        };

        setChartOptions(options);
    }, []);

    function removeErrors(e){
        let { name } = e.target;
        let newErrors = {...errors}

        delete newErrors[name];

        setErrors(newErrors);
    }

    async function fetchData(){
        

        let endpoint = helpers.createUrl(`V1/manage/contact/list?expand=product-units`)
        const res = await getApiData(endpoint)

        if(res.status === 'error'){
            // setSelectedItems([])
            setLoading(0)
            Swal.fire({
                text: res.message,
                //text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            })
        }
        else{
            setCustomers(res)
        }
    }

    function linkTo(target = ''){
        // let page = 'service-request'

        // if(!helpers.checkPermissions(["service-request-dashboard"])){
        //     page = 'technician-service-request'
        // }

        // navigate(page + params);
        navigate(target);
    }

    function displayTopItems(){
        setTopItems(
            <DataTable
                value={widget_data.top_items} 
                size="small"
                lazy
                scrollHeight="300px"
                scrollable
                stripedRows
                emptyMessage="No data to display"
            >
                <Column 
                    field="product_name" 
                    header="Name" 
                    body={({product_name, product_variant_name})=> `${product_name} (${product_variant_name})`}
                    headerStyle={{ background: '#f9fafb' }}
                />
                <Column 
                    header="Total Sales" 
                    body={({total_sales})=> helpers.formatCurrencyAmount(total_sales)} 
                    headerStyle={{ background: '#f9fafb' }}
                />
                <Column 
                    header="Sold" 
                    body={({sold_quantity, unit_name})=> <>{sold_quantity} <small>{unit_name}</small></>}
                    headerStyle={{ background: '#f9fafb' }}
                />
                {/* <Column 
                    field="product_type_id" 
                    body={({product_type_id})=> product_type_id === 1 ? 'Goods' : 'Services'} 
                    header="Type" 
                    headerStyle={{ background: '#f9fafb' }}
                /> */}
            </DataTable>
        )
    }

    function displayLowStockItems(){
        setLowStockItems(
            <DataTable
                value={widget_data.low_stock_items} 
                size="small"
                lazy
                scrollHeight="300px"
                scrollable
                stripedRows
                //resizableColumns
                emptyMessage="No data to display"
            >
                <Column 
                    field="product_name" 
                    header="Name" 
                    body={({product_name, product_variant_name})=> `${product_name} (${product_variant_name})`}
                    headerStyle={{ background: '#f9fafb' }}
                />
                <Column field="available_stock" header="Stock" headerStyle={{ background: '#f9fafb' }}/>
                <Column header="Level" body={({available_stock, reorder_point})=> helpers.displayStockLevel(available_stock, reorder_point)} headerStyle={{ background: '#f9fafb' }}/>
            </DataTable>
        )
    }

    function displaySalesOrderTable(){
        setSalesOrders(
            <DataTable
                value={widget_data.sales_orders} 
                size="small"
                lazy
                scrollHeight="300px"
                scrollable
                stripedRows
                //resizableColumns
                emptyMessage="No data to display"
            >
                <Column field="order_no" header="Order #" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="order_date" header="Date" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="customer_name" header="Customer" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="total_items" header="Orders" headerStyle={{ background: '#f9fafb' }}/>
                <Column header="Total Amount" body={({total_amount})=> helpers.formatCurrencyAmount(total_amount)}></Column>
            </DataTable>
        )

    }

    function displayPurchasesOrderTable(){
        setPurchasesOrders(
            <DataTable
                value={widget_data.purchases_orders} 
                size="small"
                lazy
                scrollHeight="300px"
                scrollable
                stripedRows
                //resizableColumns
                emptyMessage="No data to display"
            >
                <Column field="order_no" header="Order #" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="order_date" header="Date" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="vendor_name" header="Vendor" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="total_items" header="Orders" headerStyle={{ background: '#f9fafb' }}/>
                <Column header="Total Amount" body={({total_amount})=> helpers.formatCurrencyAmount(total_amount)}></Column>
            </DataTable>
        )
    }

    return (
        <>
        {/* <Layout page_title={"Hello, " + helpers.getUserName()} menu="home" breadcrumbs={false}> */}
        <Layout page_title="Customer Map" menu="customer-dashboard" breadcrumbs={false}>
                <div className="content">
                    <div className="container-fluid"  style={{position: 'relative'}}>
                        <Loader isLoading={loading}/>

                        <CustomerMap
                            customers={customers}
                        />
                    </div>{/* /.container-fluid */}
                </div>

        </Layout>
        </>
    )
}
 
export default CustomerMapDashboard;